<template>
  <div v-loading="rebuttalLoading" element-loading-spinner="nucleus-loader" style="background-color: rgb(243 242 241); padding: 10px 10px 20px 10px; border-radius: 5px;">
    <!-- New Rebuttal Loop Section -->
    <div v-for="(rebuttal, index) in rebuttals" :key="rebuttal.rebuttalId">
      <h5 class="headerWithBorderDark responseSectionCoder">
        <div v-if="rebuttal.rebuttalId" style="display: flex; align-items: center; justify-content: right;">
          <i class="mdi mdi-account" style="color: rgb(79, 27, 168); font-size: 16px; margin: 0px 5px 0px 5px;"></i>
          <span>
            {{ rebuttal.recipientContactName }} on
            <i
              ><small>{{ formatDate(rebuttal.rebuttalDate) }}</small></i
            >
          </span>
        </div>
      </h5>
      <div class="coderResponse">
        <div>
          <div v-if="calcNoChangeAddValidation()" style="padding: 10px; display: flex; justify-content: center; align-items: center;">
            <div>
              <i class="el-icon-success" style="color: #7cbe5f; font-size: 20px; margin: 0px 5px 0px 0px;"></i>
            </div>
            <div style="color: #48576a; font-size: 13px; font-weight: bold; " class="">
              Record has no recommendations, response is not required, but you may still enter a comment below
            </div>
          </div>
          <div v-if="rebuttal.rebuttalId" v-loading="loadingPut" element-loading-spinner="nucleus-loader">
            <div style="margin-left: 10px;">
              <el-form ref="form" id="form" label-position="left" label-width="150px" size="mini" style="margin-top: 0px;">
                <template v-if="index >= 0">
                  <el-form-item v-if="!calcNoChangeAddValidation()" label="Recipient Agrees with Findings">
                    <el-col style="margin-top: 3px;">
                      <input @change="RebuttalFormValidation(rebuttal)" :disabled="rebuttal.responseDate || readOnly" type="radio" name="codes" :value="true" v-model="rebuttal.agreeWithCodes" />
                      Yes
                      <input @change="RebuttalFormValidation(rebuttal)" :disabled="rebuttal.responseDate || readOnly" type="radio" name="codes" :value="false" v-model="rebuttal.agreeWithCodes" />
                      No
                    </el-col>
                  </el-form-item>
                  <el-form-item label="Auditor Response Required">
                    <el-col style="margin-top: 3px;">
                      <input @change="$emit('dirty', true)" :disabled="disableAuditorResponseRequiredNew(rebuttal, opWorksheet) || readOnly" type="radio" name="auditor" :value="true" v-model="rebuttal.responseRequired" />
                      Yes
                      <input @change="$emit('dirty', true)" :disabled="disableAuditorResponseRequiredNew(rebuttal, opWorksheet) || readOnly" type="radio" name="auditor" :value="false" v-model="rebuttal.responseRequired" /> No
                    </el-col>
                  </el-form-item>
                </template>

                <template v-if="rebuttal.rebuttalId">
                  <label class="el-form-item__label" style="width: 100%; margin-bottom: 10px;">Response Documentation</label>
                  <div v-if="!rebuttal.responseDate" style="margin-top: 15px;">
                    <div style="margin-top: 15px;">
                      <Tinymce placeholder="Please explain reason for response" class="newCommentExistingRebuttal" :height="200" v-model="rebuttal.rebuttalDocumentation" @dirty="$emit('dirty', true)" containerName="particleblobs" :disabled="readOnly"> </Tinymce>
                    </div>

                    <el-button icon="el-icon-check" style="margin-top: 10px;" v-if="worksheet.auditResult !== 'No Change'" slot="reference" class="hiaButton" plain round size="mini" @click="putRebuttalNew(rebuttal, $event)" :disabled="readOnly">Update Response</el-button>
                  </div>
                  <div v-else>
                    <HiaRichText :editable="false" v-model="rebuttal.rebuttalDocumentation" containerName="particleblobs"> </HiaRichText>
                  </div>
                </template>
              </el-form>
            </div>
          </div>
        </div>
      </div>

      <template v-if="rebuttal.rebuttalId">
        <h5 class="headerWithBorderDark responseSectionAuditor">
          <template v-if="rebuttal.responseDate">
            <div style="display: flex; align-items: center;">
              <i class="mdi mdi-account" style="color: rgb(79, 27, 168); font-size: 16px; margin-right: 7px;"></i>
              <span>
                {{ rebuttal.consultantName }} on
                <i
                  ><small>{{ formatDate(rebuttal.responseDate) }}</small></i
                >
              </span>
            </div>
          </template>
        </h5>
        <div class="auditorResponse">
          <div style="padding: 10px;">
            <el-form ref="form" id="form" label-position="left" label-width="150px" size="mini" :key="1" style="margin-top: 0px;">
              <div style="margin: 5px 0px 10px 0px; display: flex; justify-content: center; align-items: center;">
                <div>
                  <i v-if="rebuttal.rebuttalStatus === 'Auditor Response Completed' || rebuttal.rebuttalStatus === 'Auditor Response Not Required'" class="el-icon-success" style="color: #7cbe5f; font-size: 17px; margin: 0px 5px 0px 5px;"></i>

                  <i v-else class="mdi mdi-timer-sand" style="color: #87CEEB; font-size: 20px; font-weight: bold; margin: 0px 5px 0px 5px;"></i>
                </div>
                <div key="no change" style="color: #48576a; font-size: 13px; font-weight: bold; ">
                  {{ rebuttal.rebuttalStatus }}
                </div>
              </div>

              <template v-if="rebuttal.responseDate && (rebuttal.rebuttalStatus === 'Auditor Response Completed' || rebuttal.rebuttalStatus === 'Auditor Response Not Required')">
                <el-form-item label="Auditor Findings Determination">
                  <div style="margin: 6px 0 0 15px;">{{ rebuttal.agreeWithCodes ? 'N/A' : rebuttal.codesStatusCalc }}</div>
                </el-form-item>

                <label class="el-form-item__label" style="width: 100%; margin-bottom: 10px;">Auditor Response Description</label>
                <HiaRichText :editable="false" v-model="rebuttal.responseDescription" containerName="particleblobs"> </HiaRichText>
              </template>
            </el-form>
          </div>
        </div>
      </template>
    </div>
    <h5 v-if="showCoderRebuttalForm" class="headerWithBorderDark"></h5>
    <!-- New form section AEW -->
    <div v-if="showCoderRebuttalForm" class="coderRebuttalForm coderResponse">
      <div style="margin: 5px 0px 10px 0px; display: flex; justify-content: center; align-items: center;">
        <div>
          <i v-if="!calcNoChangeAddValidation()" class="el-icon-circle-plus" style="color: #7cbe5f; font-size: 17px; margin: 0px 5px 0px 5px;"></i>
          <i v-else class="el-icon-success" style="color: #7cbe5f; font-size: 20px; margin: 0px 5px 0px 0px;"></i>
        </div>
        <div style="color: #48576a; font-size: 13px; font-weight: bold; ">
          {{ calcNoChangeAddValidation() ? 'Record has no recommendations, response is not required, but you may still enter a comment below' : 'New Response Request' }}
        </div>
      </div>
      <el-form ref="form" id="form" label-position="left" label-width="150px" size="mini" :key="1" style="margin-top: 0px;">
        <el-form-item v-if="!calcNoChangeAddValidation()" label="Recipient Agrees with Findings">
          <el-col style="margin-top: 3px;"> <input :disabled="false || readOnly" type="radio" name="codes" :value="true" v-model="coderRebuttal.agreeWithCodes" @change="RebuttalFormValidation(coderRebuttal)" /> Yes <input :disabled="false || readOnly" type="radio" name="codes" :value="false" v-model="coderRebuttal.agreeWithCodes" @change="RebuttalFormValidation(coderRebuttal)" /> No </el-col>
        </el-form-item>
        <el-form-item label="Auditor Response Required">
          <el-col style="margin-top: 3px;">
            <input @change="$emit('dirty', true)" :disabled="disableAuditorResponseRequiredNew(coderRebuttal, opWorksheet) || readOnly" type="radio" name="auditor" :value="true" v-model="coderRebuttal.responseRequired" />
            Yes
            <input @change="$emit('dirty', true)" :disabled="disableAuditorResponseRequiredNew(coderRebuttal, opWorksheet) || readOnly" type="radio" name="auditor" :value="false" v-model="coderRebuttal.responseRequired" /> No
          </el-col>
        </el-form-item>
        <div style="margin-top: 15px;">
          <Tinymce placeholder="Please explain reason for response" class="newCommentExistingRebuttal" :height="250" v-model="coderRebuttal.rebuttalDocumentation" @dirty="$emit('dirty', true)" containerName="particleblobs" :disabled="readOnly"> </Tinymce>
        </div>
      </el-form>
      <div style="margin-top: 20px;">
        <el-popover ref="savePopover" style="word-break: normal;margin-left: 5px;" placement="bottom" title="" width="300" trigger="manual" popper-class="popover" :content="savePopoverContent" v-model="showSavePopover" @after-enter="handleHidePopOver('savePopover')">
          <el-button icon="el-icon-check" v-if="worksheet.auditResult === 'No Change'" slot="reference" class="hiaButton" plain round size="mini" @click="postRebuttalNew" :disabled="readOnly">Acknowledge No Change</el-button>
          <el-button icon="el-icon-plus" v-if="worksheet.auditResult !== 'No Change'" slot="reference" class="hiaButton" plain round size="mini" @click="postRebuttalNew" :disabled="readOnly">Add Response</el-button>
        </el-popover>
      </div>
      <!-- Manager Esclation -->
      <template v-if="calcManagerEscaltionBlock()">
        <div style="margin-top: 20px;">
          <div style="padding: 10px; display: flex; justify-content: center; align-items: center;">
            <div>
              <i class="el-icon-info" style="color: #e6a23c; font-size: 20px; margin-right: 10px;"></i>
            </div>
            <div style="color: #48576a; font-size: 13px; font-weight: bold;" class="">
              Response will be escalated to HIA manager
            </div>
          </div>
        </div>
      </template>
    </div>
    <el-popover ref="savePopover2" style="word-break: normal;" placement="bottom" title="" width="300" trigger="manual" popper-class="popover" :content="savePopoverContent" @after-enter="handleHidePopOver('savePopover2')"> </el-popover>
  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce'
import dateHelper from '@/mixins/date-helper'
import HiaAuthorization from '@/mixins/hiaAuthorization'
import { format, parseISO } from 'date-fns'
import { mapActions, mapState, mapMutations } from 'vuex'
import HiaRichText from '@/components/HiaRichText'

export default {
  name: 'coderOutpatientResponses',
  mixins: [dateHelper, HiaAuthorization],
  props: ['worksheet', 'ascTableId', 'opWorksheet', 'readOnly'],
  data() {
    return {
      format: format,
      parseISO: parseISO,
      disabled: true,
      newComment: '',
      loading: false,
      newMode: false,
      rebuttalLoading: false,
      showSavePopover: false,
      savePopoverContent: null,
      loadingPut: false,
      showAdditionalReviewPopover: false,
      additionalReviewPopoverContent: null,
      rebuttal: {},
      coderRebuttal: {
        agreeWithCodes: null,
        agreeWithGrouping: 0,
        responseRequired: null,
        rebuttalDate: new Date().toISOString(),
        ascTableId: this.ascTableId,
        rebuttalComments: [],
        rebuttalDocumentation: null,
        reasonForChange: this.opWorksheet.reasonForChange
      },
      showCoderRebuttalForm: true
    }
  },
  components: {
    Tinymce,
    HiaRichText
  },
  methods: {
    ...mapActions('rebuttals/', ['POST_REBUTTAL', 'DELETE_REBUTTAL', 'PUT_REBUTTAL', 'POST_ADDITIONAL_REVIEW', 'POST_REBUTTAL_NEW']),
    ...mapMutations('rebuttals/', ['SET_REBUTTALS']),
    async putComment(comment) {
      try {
        this.rebuttalLoading = true
        await this.PUT_REBUTTAL_COMMENT(comment)
        this.rebuttalLoading = false
      } catch (e) {
        this.rebuttalLoading = false
        this.$message({
          message: 'Error Editing Comment',
          type: 'error'
        })
      }
    },
    async postRebuttalNew() {
      this.coderRebuttal.consultantNumber = this.opWorksheet.reviewer
      this.coderRebuttal.projectPk = this.opWorksheet.projectPk
      this.coderRebuttal.reasonForChange = this.opWorksheet.reasonForChange
      this.coderRebuttal.recordType = 'op'
      this.coderRebuttal.patientNumber = this.opWorksheet.patAcctNum
      this.coderRebuttal.recordId = this.ascTableId

      if (this.coderRebuttal.agreeWithCodes === null && this.worksheet.reasonForChange !== 0 && this.worksheet.reasonForChange !== 75) {
        this.savePopoverContent = "Please select above whether you agree or disagree with the auditor's changes"
        this.showSavePopover = true
        return
      }

      if (this.coderRebuttal.agreeWithCodes === null && this.worksheet.reasonForChange === 75) {
        this.savePopoverContent = "Please select above whether you agree or disagree with the auditor's changes"
        this.showSavePopover = true
        return
      }

      if (this.coderRebuttal.agreeWithCodes === false && !this.coderRebuttal.rebuttalDocumentation) {
        this.savePopoverContent = 'When disagreeing with auditor, please use a comment to document your rationale for disagreement'
        this.showSavePopover = true
        return
      }

      if (this.coderRebuttal.responseRequired && !this.coderRebuttal.rebuttalDocumentation) {
        this.savePopoverContent = 'When requesting a response from the auditor, please add a comment'
        this.showSavePopover = true
        return
      }

      if (this.worksheet.reasonForChange === 0) {
        this.coderRebuttal.agreeWithCodes = 1
        if (!this.coderRebuttal.rebuttalDocumentation) {
          this.savePopoverContent = 'Please use a comment explain your reason for response'
          this.showSavePopover = true
          return
        }
      }

      try {
        this.rebuttalLoading = true
        await this.POST_REBUTTAL_NEW({ rebuttal: this.coderRebuttal, rebuttalCount: this.rebuttals.length })
        this.$message({
          message: 'Response Added Successfully',
          type: 'success'
        })
        this.clearCoderRebuttal()
        this.rebuttalLoading = false
        this.$emit('dirty', false)
        this.calcCoderRebuttalForm()
      } catch (err) {
        this.$message({
          message: 'Error Adding Response',
          type: 'error'
        })
      }
    },
    async putRebuttalNew(rebuttal, e) {
      let rebuttalCopy = JSON.parse(JSON.stringify(rebuttal))

      if (!rebuttal.rebuttalDocumentation && rebuttal.responseRequired) {
        this.savePopoverContent = 'Response Documentation must contain a value.'
        this.openSavePopover(e)
        rebuttal.rebuttalDocumentation = rebuttal.originalRebuttalDocumentation
        return false
      }

      if (rebuttal.agreeWithCodes === false) {
        rebuttalCopy.responseRequired = true
      }

      if (rebuttal.agreeWithCodes === true && this.opWorksheet.reasonForChange !== 0 && this.rebuttal.responseRequired === null) {
        rebuttalCopy.responseRequired = false
      }

      try {
        rebuttalCopy.projectPk = this.opWorksheet.projectPk
        rebuttalCopy.recordType = 'op'
        rebuttalCopy.patientNumber = this.opWorksheet.patAcctNum
        rebuttalCopy.recordId = this.ascTableId
        this.loadingPut = true
        await this.PUT_REBUTTAL(rebuttalCopy)
        this.loadingPut = false
        this.$emit('dirty', false)
        this.calcCoderRebuttalForm()
        this.$message({
          message: 'Response Updated Successfully',
          type: 'success'
        })
      } catch (e) {
        this.$message({
          message: 'Error Updating Response',
          type: 'error'
        })
      }
    },
    async RebuttalFormValidation(rebuttal) {
      if (rebuttal.agreeWithCodes === false) {
        rebuttal.responseRequired = true
      }

      if (rebuttal.agreeWithCodes === true) {
        rebuttal.responseRequired = false
      }

      this.$emit('dirty', true)
    },
    disableAuditorResponseRequiredNew(rebuttal, opWorksheet) {
      if (opWorksheet.reasonForChange === 0 && this.rebuttals.length === 0) {
        return false
      }

      if (opWorksheet.reasonForChange === 75) {
        if (rebuttal.responseDate) {
          return true
        }
        if (rebuttal.agreeWithCodes) {
          return false
        }
      }

      if (opWorksheet.reasonForChange !== 75 && opWorksheet.reasonForChange !== 0) {
        if (rebuttal.responseDate) {
          return true
        }
        if (rebuttal.agreeWithCodes) {
          return false
        }
      }

      if (opWorksheet.reasonForChange === 0 && this.rebuttals.length > 0) {
        if (rebuttal.responseDate) {
          return true
        }
        if (rebuttal.agreeWithCodes) {
          return false
        }
        return false
      }

      return true
    },
    handleHidePopOver(ref) {
      const popper = this.$refs[ref]
      const handler = e => {
        if (e.target !== popper.$el) {
          popper.doDestroy()
          popper.doClose()
        }
        document.removeEventListener('click', handler, false)
      }
      document.addEventListener('click', handler, false)
    },
    clearCoderRebuttal() {
      this.coderRebuttal.agreeWithCodes = null
      this.coderRebuttal.agreeWithGrouping = 0
      this.coderRebuttal.responseRequired = null
      this.coderRebuttal.rebuttalDate = new Date().toISOString()
      this.coderRebuttal.ascTableId = this.ascTableId
      this.coderRebuttal.rebuttalComments = []
      this.coderRebuttal.rebuttalDocumentation = null
      this.coderRebuttal.reasonForChange = this.opWorksheet.reasonForChange
    },
    calcCoderRebuttalForm() {
      if (this.rebuttals.length) {
        let lastRebuttal = this.rebuttals[this.rebuttals.length - 1]
        if (this.calcNoChangeAddValidation() && lastRebuttal.responseDate) {
          return true
        }

        if (!lastRebuttal.responseRequired && lastRebuttal.responseDate) {
          return true
        }

        if (!lastRebuttal.responseRequired) {
          this.showCoderRebuttalForm = false
          return false
        }

        if (lastRebuttal.rebuttalStatus === 'Auditor Response Completed' || lastRebuttal.rebuttalStatus === 'Auditor Response Not Required') {
          this.showCoderRebuttalForm = true
          return true
        }
        this.showCoderRebuttalForm = false
        return false
      }
      this.showCoderRebuttalForm = true
      return true
    },
    calcManagerEscaltionBlock() {
      if (this.rebuttals.length >= 2 && this.coderRebuttal.agreeWithCodes === false) {
        let lastRebuttal = this.rebuttals[this.rebuttals.length - 1]
        if (this.opWorksheet.reasonForChange !== 75 && this.opWorksheet.reasonForChange !== 0) {
          if (lastRebuttal.responseRequired && lastRebuttal.agreeWithCodes) {
            return false
          }
          return true
        }

        if (lastRebuttal.responseRequired && lastRebuttal.agreeWithCodes) {
          return false
        }

        if (!lastRebuttal.responseRequired) {
          return false
        }

        if (!lastRebuttal.responseDate) {
          return false
        }
        return true
      }
      return false
    },
    calcNoChangeAddValidation() {
      if (this.opWorksheet.reasonForChange === 0 && this.rebuttals.length === 0) {
        return true
      }
      if (this.rebuttals.length > 0 && this.rebuttals[0].reasonForChange === 0) {
        return true
      }
      return false
    },
    openSavePopover(e) {
      if (!e) {
        return
      }

      const popper = this.$refs.savePopover2

      popper.doDestroy()
      popper.doClose()

      this.$nextTick(() => {
        this.popperClickTarget = e.target
        popper.doDestroy()
        popper.referenceElm = this.popperClickTarget
        this.isOpen = true
        popper.doShow()
      })
    }
  },
  created: function() {
    this.calcCoderRebuttalForm()
  },
  computed: {
    ...mapState('rebuttals/', ['rebuttals']),
    ...mapState('user/', ['user']),
    ...mapState('myProjects/', ['responseRow', 'responseDRG', 'responsePatStat', 'responsePOO'])
    // rebuttal() {
    //   return this.rebuttals.length > 0 ? this.rebuttals[0] : {}
    // }
  },
  watch: {
    responseDRG(val) {
      this.coderRebuttal.rebuttalDocumentation = this.coderRebuttal.rebuttalDocumentation ? this.coderRebuttal.rebuttalDocumentation : ''
      if (val.originalDrg && val.recommendedDrg) {
        this.coderRebuttal.rebuttalDocumentation += `Original DRG ${val.originalDrg} changed to ${val.recommendedDrg}<br />`
      } else {
        this.coderRebuttal.rebuttalDocumentation += `DRG changed to ${val.recommendedDrg}<br />`
      }
    },
    responsePatStat(val) {
      this.coderRebuttal.rebuttalDocumentation = this.coderRebuttal.rebuttalDocumentation ? this.coderRebuttal.rebuttalDocumentation : ''
      if (val.originalPatStat && val.recommendedPatStat) {
        this.coderRebuttal.rebuttalDocumentation += `Original Patient Status ${val.originalPatStat} changed to ${val.recommendedPatStat}<br />`
      } else {
        this.coderRebuttal.rebuttalDocumentation += `Patient Status changed to ${val.recommendedPatStat}<br />`
      }
    },
    responsePOO(val) {
      this.coderRebuttal.rebuttalDocumentation = this.coderRebuttal.rebuttalDocumentation ? this.coderRebuttal.rebuttalDocumentation : ''
      if (val.originalPoo && val.recommendedPoo) {
        this.coderRebuttal.rebuttalDocumentation += `Original Point of Origin ${val.originalPoo} changed to ${val.recommendedPoo}<br />`
      } else {
        this.coderRebuttal.rebuttalDocumentation += `Point of Origin changed to ${val.recommendedPoo}<br />`
      }
    },
    responseRow(val) {
      this.coderRebuttal.rebuttalDocumentation = this.coderRebuttal.rebuttalDocumentation ? this.coderRebuttal.rebuttalDocumentation : ''
      if (val.reasonForChange === 'Resequence PDx') {
        this.coderRebuttal.rebuttalDocumentation += `Principal Dx resequenced to ${val.recommendedDx}<br />`
        return
      }

      if (val.reasonForChange === 'Resequence SDx') {
        this.coderRebuttal.rebuttalDocumentation += `Secondary Dx resequenced to ${val.recommendedDx}<br />`
        return
      }

      if (val.originalDx && val.recommendedDx && !val.originalDeleted) {
        this.coderRebuttal.rebuttalDocumentation += `Dx ${val.originalDx} changed to ${val.recommendedDx}<br />`
      }
      if (!val.originalDx && val.recommendedDx) {
        this.coderRebuttal.rebuttalDocumentation += `Dx ${val.recommendedDx} added<br />`
      }
      if (val.originalDeleted && val.originalDx) {
        this.coderRebuttal.rebuttalDocumentation += `Dx ${val.originalDx} deleted<br />`
      }

      if (val.recommendedPOA) {
        this.coderRebuttal.rebuttalDocumentation += `Dx POA ${val.recommendedPOA} recommended on ${val.recomendedDx || val.originalDx}<br />`
      }

      if (val.originalPx && val.recommendedPx && !val.originalDeleted) {
        this.coderRebuttal.rebuttalDocumentation += `Px ${val.originalPx} changed to ${val.recommendedPx}<br />`
      }

      if (!val.originalPx && val.recommendedPx) {
        this.coderRebuttal.rebuttalDocumentation += `Px ${val.recommendedPx} added<br />`
      }
      if (val.originalDeleted && val.originalPx) {
        this.coderRebuttal.rebuttalDocumentation += `Px ${val.originalPx} deleted<br />`
      }

      if (val.originalCPT && val.recommendedCPT && !val.originalDeleted) {
        this.coderRebuttal.rebuttalDocumentation += `CPT ${val.originalCPT} changed to ${val.recommendedCPT}<br />`
      }
      if (!val.originalCPT && val.recommendedCPT) {
        this.coderRebuttal.rebuttalDocumentation += `CPT ${val.recommendedCPT} added<br />`
      }
      if (val.originalDeleted && val.originalCPT) {
        this.coderRebuttal.rebuttalDocumentation += `CPT ${val.originalCPT} deleted<br />`
      }
    }
  }
}
</script>

<style scoped>
/* >>>.el-collapse-item__header,
  >>>.el-collapse-item__content {
    background-color: rgb(243 242 241);
  } */

.coderResponse {
  background-color: rgb(232 235 249);
  /* background-color: rgb(243 242 241); */
  border-radius: 5px;
  margin-right: 15px;
  margin-left: 10%;
  padding: 10px;
}

.auditorResponse {
  background-color: #ffffff;
  padding: 10px;
  border-radius: 5px;
  margin-right: 10%;
  margin-left: 15px;
  margin-bottom: 25px;
}

.responseSectionCoder {
  text-align: right;
}

.responseSectionAuditor {
  margin-top: 20px;
}

>>> .rich-text {
  overflow-y: auto !important;
  max-height: 150px !important;
}

.richText img {
  width: 100%;
  /* or any custom size */
  height: 100%;
  object-fit: contain;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  height: 0px;
}

>>> .tox-tinymce {
  border-radius: 5px;
}

.textField {
  border: 1px solid #dcdfe6;
  background: #fff;
  border-radius: 4px;
  padding: 10px;
  margin: 10px 10px 20px 0px;
  min-height: 30px;
  font-size: 14px;
  overflow-x: auto;
  white-space: pre-line;
}
</style>
